import { render, staticRenderFns } from "./FormMobileInput.vue?vue&type=template&id=4f8dc2b0&lang=pug&"
import script from "./FormMobileInput.vue?vue&type=script&lang=js&"
export * from "./FormMobileInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports